import React, { PureComponent } from 'react';
import { array, bool, func } from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { BaseClickable, palette } from '@solvhealth/jigsaw-v1';
import { colors } from '../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../constants/text';
import { ReminderStatus } from '../../../../../Account/Profile/Reminders/util/reminders';
import ModalController from './ModalController';
import Sources from './Modals/Sources';
import { isEmptyObject } from '../../../../../../core/util/object';
import { isReminderComplete } from '../../components/Tiles/HealthChecklist/util';
import { smallerThanOrEqualTo } from '../../../../../../core/util/styledComponents';
import { Tile } from './Tile';
import { UserProfile } from '~/core/dapi/models';

const Root = styled.div.withConfig({ componentId: 'sc-15ytkpp-0' })`
  margin: auto;
`;

const ProgressContainer = styled.div.withConfig({ componentId: 'sc-15ytkpp-1' })`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 16px;
  ${smallerThanOrEqualTo.sm`
    padding: 0;
  `}
`;

const fill = keyframes`
  from {
    transform: translateX(-100%);
  } to {
    transform: translateX(0);
  }
`;

const ProgressBar = styled.div.withConfig({ componentId: 'sc-15ytkpp-2' })`
  height: 8px;
  width: 22px;
  margin-right: 4px;
  position: relative;
  background-color: ${palette.gray[200]};
  border-radius: 3px;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: translateX(-100%);
    height: 100%;
    background-color: ${palette.crunchberry.base};
    ${({
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'filled' does not exist on type 'Pick<Det... Remove this comment to see the full error message
      filled,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'offset' does not exist on type 'Pick<Det... Remove this comment to see the full error message
      offset,
    }) =>
      filled &&
      css`
        animation: ${fill} 150ms linear ${offset * 165}ms forwards;
      `};
  }
`;

const ProgressComplete = styled.span.withConfig({ componentId: 'sc-15ytkpp-3' })`
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  color: ${palette.gray[500]};
  margin-left: 8px;
`;

const Done = styled.span.withConfig({ componentId: 'sc-15ytkpp-4' })`
  color: ${palette.crunchberry.base};
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'array' refers to a value, but is being used as a ... Remove this comment to see the full error message
  tiles?: array;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  setBirthSex?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  fetchReminders?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  createReminder?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  updateReminder?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  deleteReminder?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  clearReminders?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  setReminderDay?: func;
  userReminders?: object;
  userProfile?: UserProfile;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  shouldLoadHealthCareCheckList?: bool;
};

type State = {
  activeModalId: string | null;
  activeTile: Tile | null;
};

export default class HealthChecklistContainer extends PureComponent<Props, State> {
  state = { activeModalId: null, activeTile: null };

  componentDidMount() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    this.fetchReminders();
  }

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'prevProfileId' implicitly has an ... Remove this comment to see the full error message
  componentDidUpdate = ({ userProfile: { user_profile_id: prevProfileId } }) => {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'user_profile_id' does not exist on type ... Remove this comment to see the full error message
      userProfile: { user_profile_id: currProfileId },
    } = this.props;
    if (prevProfileId !== currProfileId) {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
      this.fetchReminders();
    }
  };

  getCompleted() {
    const { userReminders } = this.props;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return Object.values(userReminders.result || {}).reduce(
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      (acc, reminder) => acc + ReminderStatus.complete.includes(ReminderStatus.getStatus(reminder)),
      0
    );
  }

  getNumberCompletedReminders = () => {
    // sometimes things get weird and there are more completed reminders than visible tiles
    const { tiles } = this.props;
    const completed = this.getCompleted();
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    return completed > tiles.length ? tiles.length : completed;
  };

  fetchReminders = (andClear: any) => {
    const {
      fetchReminders,
      clearReminders,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'user_profile_id' does not exist on type ... Remove this comment to see the full error message
      userProfile: { user_profile_id: userProfileId },
    } = this.props;

    andClear && clearReminders();
    fetchReminders(userProfileId);
  };

  sortReminders = (tileA: any, tileB: any) => {
    try {
      const {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'result' does not exist on type 'object |... Remove this comment to see the full error message
        userReminders: { result },
      } = this.props;
      const reminderTileA = result[tileA.id];
      const reminderTileB = result[tileB.id];

      // if neither is set, respect original sort order
      if (isEmptyObject(reminderTileA) && isEmptyObject(reminderTileB))
        return tileA.sortIdx - tileB.sortIdx;

      // non interacted tiles come first
      if (isEmptyObject(reminderTileA)) return -1;
      if (isEmptyObject(reminderTileB)) return 1;

      // done tiles come last
      if (isReminderComplete(reminderTileA)) return 1;
      if (isReminderComplete(reminderTileB)) return -1;

      // not done tiles in the middle
      if (reminderTileA.status === ReminderStatus.NOT_DONE) return -1;
      if (reminderTileB.status === ReminderStatus.NOT_DONE) return 1;

      return tileA.sortIdx - tileB.sortIdx;
    } catch (e) {
      return tileA.sortIdx - tileB.sortIdx;
    }
  };

  openModal = (modalId: any, activeTile = {}) =>
    this.setState({ activeModalId: modalId, activeTile });

  render() {
    const { children, tiles, ...reminderProps } = this.props;
    const [title, description, taskList] = React.Children.toArray(children);
    const { activeModalId, activeTile } = this.state;
    const numberComplete = this.getNumberCompletedReminders();

    if (!this.props.shouldLoadHealthCareCheckList) return null;

    return (
      <Root>
        {title}

        <BaseClickable onClick={() => this.openModal(Sources.MODAL_ID)}>
          {description}
        </BaseClickable>

        <ProgressContainer>
          {tiles.map((_: any, i: any) => (
            // @ts-expect-error ts-migrate(2769) FIXME: Property 'filled' does not exist on type 'Intrinsi... Remove this comment to see the full error message
            <ProgressBar filled={i < numberComplete} key={i} offset={i} />
          ))}

          <ProgressComplete>
            <Done>{numberComplete}</Done> of {tiles.length} complete
          </ProgressComplete>
        </ProgressContainer>
        {/* @ts-ignore */}
        {React.cloneElement(taskList, {
          openModal: this.openModal,
          ...reminderProps,
          // @ts-ignore
          tiles: taskList.props.tiles.sort(this.sortReminders),
        })}

        <ModalController
          activeModalId={activeModalId}
          activeTile={activeTile}
          openModal={this.openModal}
          {...reminderProps}
        />
      </Root>
    );
  }
}
